import axios from 'axios'

import { UserRole } from 'src/models/User'

export const START_EARLY_WINDOW_HOURS = 24

export const ROLES_THAT_CAN_EDIT_ORDER: UserRole[] = ['customer_admin', 'customer_content_manager', 'collection_manager', 'court_reporter']

const MISSING_PRODUCT_ERROR_CODE = 3024

// Preserves the original end time; extends duration to cover the earlier start.
export const calculateExtendedDuration = (startAt: string, newStartAt: string, maxDuration: number): number => {
    const endTimeMs = new Date(startAt).getTime() + maxDuration * 1000
    const newStartMs = new Date(newStartAt).getTime()
    const newDurationSeconds = Math.round((endTimeMs - newStartMs) / 1000)

    return newDurationSeconds < 0 ? -1 : newDurationSeconds
}

export const isMissingProductError = (error: unknown): boolean => {
    if (!axios.isAxiosError(error)) {
        return false
    }

    const errors: { code?: number }[] = error.response?.data?.errors ?? []

    return errors.some((e) => e.code === MISSING_PRODUCT_ERROR_CODE)
}
